import React from 'react';
import { motion } from 'framer-motion';
import { ClientsTable } from '@/components/clients/ClientsTable';
import { Sparkles } from 'lucide-react';

export const HomePage: React.FC = () => {
  return (
    <div className="space-y-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="space-y-4"
      >
        <h1 className="text-4xl font-bold bg-gradient-to-r from-gray-900 via-stratos-gold to-gray-900 bg-clip-text text-transparent flex items-center gap-3">
          <Sparkles className="w-8 h-8 text-stratos-gold" />
          Accueil - Gestion des Clients
        </h1>
        <p className="text-lg text-gray-600 max-w-3xl">
          Gérez votre portefeuille de restaurants clients. Ajoutez, modifiez ou supprimez des établissements.
        </p>
  
      </motion.div>

      {/* Table CRUD des clients */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
      >
        <ClientsTable />
      </motion.div>
    </div>
  );
};